import { useEffect, useState } from "react";
import AddGroup from "./Component/AddGroup";
import UseToggle from "../../Hooks/UseToggle";
import AddProject from "./Component/AddProject";
import ChatLayout from "./ChatLayout/ChatLayout";
import ProfileDetails from "../UserProfile/ProfileDetails";
import GroupDirectories from "./Directories/GroupDirectories";
import ProjectDirectories from "./Directories/ProjectDirectories";
import TeamDirectories from "./Directories/TeamDirectories/TeamDirectories";
import { FaCircle } from "react-icons/fa";
import { Dropdown } from "react-bootstrap";
import { IoCubeOutline } from "react-icons/io5";
import { SlLayers, SlLock } from "react-icons/sl";
import { userServices } from "../../APIServices/UserData/userServices";
import { FiBook, FiMoreVertical, FiPlus, FiSettings, FiUserPlus } from "react-icons/fi";
import { groupAndProjectServices } from "../../APIServices/WorkBridge/TeamManagement/groupAndProjectServices";
import { checkedAssignedUser } from "../../APIServices/GoApiServices/chatService";
import { bookmarkTeamProjectServices } from "../../APIServices/WorkBridge/TeamManagement/bookmarkTeamProjectServices";

const TeamWorkspace = ({ currentUserData, selectedProfile, setSelectedProfile }) => {
  const toggles = UseToggle();

  const [groupList, setGroupList] = useState([]);
  const [projectList, setProjectList] = useState([]);
  const [memberList, setMemberList] = useState([]);
  const [activeChannel, setActiveChannel] = useState(null);
  const [activeThread, setActiveThread] = useState(null);
  const [showDirectory, setShowDirectory] = useState(null);
  const [activeSection, setActiveSection] = useState(false);
  const [groupId, setGroupId] = useState("");
  const [assignCheck, setAssignCheck] = useState("");
  const [selectedMemberIds, setSelectedMemberIds] = useState([]);
  const [bookmarked, setBookmarked] = useState([]);

  const getGroupAndProjectList = async () => {
    const data = await groupAndProjectServices.getGroupAndProjectList("all", "all");
    const result = data?.data || [];
    setGroupList(result.filter((i) => i.category === "group"));
    setProjectList(result.filter((i) => i.category === "project"));
  };

  const getMembers = async () => {
    const data = await userServices.getMembers("active");
    setMemberList(data?.data || []);
  };

  const getBookmarkTeamProjectList = async () => {
    const data = await bookmarkTeamProjectServices.getBookmarkTeamProjectList();
    setBookmarked(data?.data || []);
  };

  const getSingleGroupAndProject = async () => {
    let data = await groupAndProjectServices.getSingleGroupAndProject(activeChannel?.gpId);
    let result = data?.data?.assignedUser || [];
    setSelectedMemberIds(result);
  };

  const handleChannelClick = (channel) => {
    setActiveChannel(channel);
    setShowDirectory("");
    setGroupId(channel?.gpId || channel?.userId || "");
  };

  const token =
    currentUserData?.token ||
    currentUserData?.accessToken ||
    currentUserData?.authToken ||
    localStorage.getItem("token") ||
    "";

  useEffect(() => {
    getMembers();
    getGroupAndProjectList();
    getBookmarkTeamProjectList();
  }, []);

  useEffect(() => {
    if (activeChannel?.gpId) getSingleGroupAndProject();
    else setSelectedMemberIds([]);
  }, [activeChannel]);

  useEffect(() => {
    let cancelled = false;

    async function run() {
      if (!groupId || !token || !currentUserData?.userId) {
        setAssignCheck("");
        return;
      }

      try {
        const res = await checkedAssignedUser(groupId, currentUserData?.userId, token);
        if (cancelled) return;
        setAssignCheck({ assigned: Boolean(res?.assigned) });
      } catch {
        if (cancelled) return;
        setAssignCheck("");
      }
    }

    run();
    return () => {
      cancelled = true;
    };
  }, [groupId, currentUserData?.userId, token]);



  return (
    <>
      <aside className="channels-panel border-end">
        <div className="channels-header pt-3 px-2">
          <strong>Work Bridge</strong>
          <FiSettings />
        </div>

        <div className="overflow-auto" style={{ height: "calc(100vh - 56px)" }}>
          {bookmarked?.length > 0 &&
            <div className="channels-section mb-4">
              <div className="section-title px-2 fw-bold">
                <span className="hstack gap-2 CP">Starred </span>{" "}
                {currentUserData?.roleType === "organization" &&
                  <Dropdown align="end">
                    <Dropdown.Toggle as="span" className="CP" id="team-dropdown">
                      <FiMoreVertical />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item
                        style={{ fontSize: 13 }}
                        title="Create Group"
                        className="hstack gap-2"
                        onClick={toggles.setToggle}
                      >
                        <FiPlus /> Create Group
                      </Dropdown.Item>
                      <Dropdown.Item
                        style={{ fontSize: 13 }}
                        title="Create Group"
                        className="hstack gap-2"
                        onClick={toggles.setToggle1}
                      >
                        <FiPlus /> Create Project
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                }
              </div>

              <div className="px-2">
                {bookmarked.map((star) => (
                  <div
                    key={star.gpId}
                    className={`channel-item ${(activeChannel?.gpId || activeChannel?.userId) === (star.gpId || star.userId) ? "active" : ""}`}
                    onClick={() => handleChannelClick(star)}
                  >
                    {star.type === "private" ? <SlLock /> : <SlLayers />} {star.name}
                  </div>
                ))}
              </div>
            </div>
          }
          <div className="channels-section mb-4">
            <div className="section-title px-2 fw-bold">
              <span className="hstack gap-2 CP">Groups </span>{" "}
              <Dropdown align="end">
                <Dropdown.Toggle as="span" className="CP" id="team-dropdown">
                  <FiMoreVertical />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {currentUserData?.roleType === "organization" &&
                    <Dropdown.Item
                      style={{ fontSize: 13 }}
                      title="Create Group"
                      className="hstack gap-2"
                      onClick={toggles.setToggle}
                    >
                      <FiPlus /> Create Group
                    </Dropdown.Item>
                  }
                  <Dropdown.Item
                    style={{ fontSize: 13 }}
                    title="Team Directory"
                    className="hstack gap-2"
                    onClick={() => setShowDirectory("nenbers")}
                  >
                    <FiBook /> Directory
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>

            <div className="px-2">
              {groupList.map((group) => (
                <div
                  key={group.gpId}
                  className={`channel-item ${activeChannel?.gpId === group.gpId ? "active" : ""}`}
                  onClick={() => handleChannelClick(group)}
                >
                  {group.type === "private" ? <SlLock /> : <SlLayers />} {group.name}
                </div>
              ))}
            </div>
          </div>

          <div className="channels-section mb-4">
            <div className="section-title px-2 fw-bold">
              <span className="hstack gap-2 CP">Projects </span>{" "}
              <Dropdown align="end">
                <Dropdown.Toggle as="span" className="CP" id="team-dropdown">
                  <FiMoreVertical />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {currentUserData?.roleType === "organization" &&
                    <Dropdown.Item
                      style={{ fontSize: 13 }}
                      title="Add Projects"
                      className="hstack gap-2"
                      onClick={toggles.setToggle1}
                    >
                      <FiPlus /> Add Projects
                    </Dropdown.Item>
                  }
                  <Dropdown.Item
                    style={{ fontSize: 13 }}
                    title="Team Directory"
                    className="hstack gap-2"
                    onClick={() => setShowDirectory("projects")}
                  >
                    <FiBook /> Directory
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>

            <div className="overflow-auto px-2" style={{ maxHeight: 150 }}>
              {projectList?.map((project) => (
                <div
                  key={project.gpId}
                  className={`channel-item ${activeChannel?.gpId === project.gpId ? "active" : ""}`}
                  onClick={() => handleChannelClick(project)}
                >
                  {project.type === "private" ? <SlLock /> : <IoCubeOutline />} {project.name}
                </div>
              ))}
            </div>
          </div>

          <div className="channels-section mb-4">
            <div className="section-title px-2 fw-bold d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center gap-2 CP">
                <span>Team</span>
              </div>
              <Dropdown align="end">
                <Dropdown.Toggle as="span" className="CP" id="team-dropdown">
                  <FiMoreVertical />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {currentUserData?.roleType === "organization" &&
                    <Dropdown.Item
                      style={{ fontSize: 13 }}
                      title="Invite Members"
                      className="hstack gap-2"
                      onClick={() => setShowDirectory("")}
                    >
                      <FiUserPlus /> Invite Members
                    </Dropdown.Item>
                  }
                  <Dropdown.Item
                    style={{ fontSize: 13 }}
                    title="Team Directory"
                    className="hstack gap-2"
                    onClick={() => setShowDirectory("team")}
                  >
                    <FiBook /> Directory
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>

            <div className="px-2">
              {memberList?.map((member) => (
                <div
                  key={member.userId}
                  className={`channel-item position-relative ${activeChannel?.userId === member.userId ? "active" : ""
                    }`}
                  onClick={() => handleChannelClick(member)}
                >
                  <img
                    className="rounded-2 border me-1"
                    src={
                      member.icon ||
                      "https://password-super.s3.ap-south-1.amazonaws.com/icons/useryellow.png"
                    }
                    alt={member.name}
                    style={{ height: 25 }}
                  />
                  <div
                    className={`position-absolute z-2 ${member.liveStatus === "online"
                      ? "text-success"
                      : member.liveStatus === "away"
                        ? "text-warning"
                        : "text-secondary small rounded-1"
                      }`}
                    style={{ bottom: -2, left: 28 }}
                  >
                    <FaCircle style={{ fontSize: 8 }} />
                  </div>
                  {member.name} {member?.own && "(You)"}
                </div>
              ))}
            </div>
          </div>
        </div>
      </aside>

      <div className="chat-wrapper">
        <div className="chat-main">
          {showDirectory === "groups" ? (
            <GroupDirectories
              channelName={activeChannel}
              memberList={memberList}
              currentUserData={currentUserData}
              directoryName="Group Directory"
            />
          ) : showDirectory === "projects" ? (
            <ProjectDirectories
              channelName={activeChannel}
              memberList={memberList}
              directoryName="Project Directory"
            />
          ) : showDirectory === "team" ? (
            <TeamDirectories
              members={memberList}
              activeSection={activeSection}
              selectedData={selectedProfile}
              directoryName="Team Directory"
              setActiveSection={setActiveSection}
              onClose={() => setSelectedProfile(null)}
            />
          ) : (
            <ChatLayout
              members={memberList}
              activeThread={activeThread}
              setActiveThread={setActiveThread}
              channelName={activeChannel}
              currentUserData={currentUserData}
              selectedMemberIds={selectedMemberIds}
              assignCheck={assignCheck}
              setSelectedProfile={setSelectedProfile}
              getBookmarkTeamProjectList={getBookmarkTeamProjectList}
            />
          )}
        </div>

        {selectedProfile && (
          <ProfileDetails userId={currentUserData?.userId} onClose={() => setSelectedProfile(null)} />
        )}
      </div>

      <AddGroup
        Show={!toggles.toggle}
        Hide={toggles.setToggle}
        Title="Add new Group"
        getGroupAndProjectList={getGroupAndProjectList}
      />

      <AddProject
        Show={!toggles.toggle1}
        Hide={toggles.setToggle1}
        Title="Add new Project"
        getGroupAndProjectList={getGroupAndProjectList}
      />
    </>
  );
};

export default TeamWorkspace;
